<template>
  <v-layout
    class="interaction-topper type-and-timestamp-interaction-topper px-2 py-3 mb-2 primary"
    align-center
    justify-start
  >
    <v-flex xs6>
      <v-layout
        justify-center
        align-center
      >
        <v-icon
          left
          color="white"
        >
          {{interactionTypeData[localInteraction.interactionType].icon}}
        </v-icon>
        <span class="white--text">
          {{interactionTypeData[localInteraction.interactionType].label}}
        </span>
      </v-layout>
    </v-flex>
    <v-flex xs6>
      <v-layout
        justify-center
        align-center
      >
        <v-icon
          left
          color="white"
        >
          access_time
        </v-icon>
        <span class="white--text">
          {{convertedTimestamp}}
        </span>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import Interaction from '../../mixins/Interaction';
import { interactionTypeData } from '../../constants';

export default {
  name: 'TypeAndTimestampTopper',
  mixins: [
    Interaction,
  ],
  computed: {
    interactionTypeData() {
      return interactionTypeData;
    },
    convertedTimestamp() {
      if (
        !this.$_.isFinite(this.localInteraction.displayOutTime)
        || this.localInteraction.displayOutTime === this.localInteraction.displayInTime
      ) {
        return this.localInteraction.displayInTime.toHoursMinutesSeconds();
      }
      return `${this.localInteraction.displayInTime.toHoursMinutesSeconds()} - ${this.localInteraction.displayOutTime.toHoursMinutesSeconds()}`;
    },
  },
};
</script>
